export const menuOptions = {
  settings: "Settings",
};

// order matters
export const themes = {
  candySnake: { key: "candySnake", value: "Snake V2" },
  colorSnake: { key: "colorSnake", value: "Snake V2" },
  deSnaker: { key: "deSnaker", value: "DeSnaker" },
};
